import { redirect } from 'react-router-dom';
import AuthContext from '../Components/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState, useContext, useRef } from 'react';
import '../Components/Style.css';
import axios from 'axios';
import { toast } from "react-toastify";
import Dashboard from '../Components/Dashboard';
import ipaddress from '../Components/IpAddress';
import { Button } from 'react-bootstrap';
import { faBarcode, faForward, faHand, faSearch, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Table,
} from "reactstrap";
import Rate_Chart_Service from "../services/Rate_Chart_Service";
import InviceService from "../services/InviceService"


export default function HoldRelease() {


  const navigate = useNavigate();
  const {
    jwtToken,
    userId,
    username,
    branchId,
    companyid,
    role,
    companyname,
    branchname,
    login,
    logout,
  } = useContext(AuthContext);
  const { isAuthenticated } = useContext(AuthContext);
  const [getSir, setGetSir] = useState('');

  const [loading, setLoading] = useState(false);

  const [getSir1, setGetSir1] = useState('');

  // If the user is not authenticated, redirect to the login page
  useEffect(() => {
    if (!isAuthenticated) {

      navigate('/login?message=You need to be authenticated to access this page.');
    }
  }, [isAuthenticated, navigate]);

  const printBarcode = async (mawb, seino, nop, sirdate, reqdate, niptStatus, requestId) => {
    try {
        const response = await InviceService.getbarcode(mawb, seino, nop, sirdate, reqdate, "EXPORT", niptStatus, requestId);

        // Check if the response status is OK (200)
        if (response.status === 200) {
            // Get the raw response data as base64-encoded string
            const newWindow = window.open('', '_blank');
            newWindow.document.write(response.data);
            setTimeout(() => {
                newWindow.print(); // Open the print dialog
            }, 100);
        } else {
            throw new Error('Failed to generate PDF');
        }
    } catch (error) {
    }
};

  const scanHoldData = async (companyid, branchId, scanData) => {
    setLoading(true);

    try {
      const response = await Rate_Chart_Service.scanHoldData(
        companyid,
        branchId,
        scanData, userId
      );


      const data = response.data;

      // Print barcode only when a new SER number is generated
if (data.shouldSERGenerate === true) {
  await printBarcode(
      data.sbNo,
      data.serNo,
      data.noOfPackages,
      data.serDate,
      data.sbDate,
      "N",
      "1232"
  );
}

getHoldList("HOLD");

// Show backend success message
if (data?.message) {
  toast.success(data.message, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 1500,
    style: {
        width: "fit-content",
        maxWidth: "none",
        whiteSpace: "nowrap",
    },
});
} else {
        toast.success("Parcel successfully put on hold.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1500,
        });
      }

    } catch (error) {

      console.error(
        "Error in scanHoldData request:",
        error
      );

      // Get message returned by backend
      const message =
        error?.response?.data ||
        "Oops something went wrong!";

      toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1500,
        style: {
            width: "fit-content",
            maxWidth: "none",
            whiteSpace: "nowrap",
        },
      });

    } finally {
      setGetSir('');
      setLoading(false);
    }
  };




  const handlesub = () => {
    scanHoldData(companyid, branchId, getSir);
  }

  const handlesub1 = () => {

    scanReleaseData(companyid, branchId, getSir1);
  }


  const scanReleaseData = async (companyid, branchId, scanData) => {
    setLoading(true);

    try {
      const response = await Rate_Chart_Service.scanReleaseData(
        companyid,
        branchId,
        scanData, userId
      );
      getHoldList('RELEASE');
      // Backend success message
      if (response?.data) {
        toast.success(response.data, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1500,
          style: {
              width: "fit-content",
              maxWidth: "none",
              whiteSpace: "nowrap",
          },
        });
      } else {
        toast.success("Parcel successfully released.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1500,
          style: {
              width: "fit-content",
              maxWidth: "none",
              whiteSpace: "nowrap",
          },
        });
      }

    } catch (error) {

      console.error(
        "Error in scanReleaseData request:",
        error
      );

      // Get message returned by backend
      const message =
        error?.response?.data ||
        "Oops something went wrong!";

      toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1500,
        style: {
            width: "fit-content",
            maxWidth: "none",
            whiteSpace: "nowrap",
        },
      });

    } finally {
      setGetSir1('');
      setLoading(false);
    }
  };




  const [holdList, setHoldList] = useState([]);

  const getHoldList = async (type) => {
    try {
      setLoading(true);

      const response = await Rate_Chart_Service.getHoldData(
        companyid,
        branchId,
        type
      );

      if (type === "HOLD") {
        setHoldList(response.data);
      } else if (type === "RELEASE") {
        setReleaseData(response.data);
      }

    } catch (error) {
      console.error("Error in getHoldList:", error);

      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        "Unable to fetch hold/release data.";

      toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1500,
      });

    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    getHoldList('HOLD');
  }, [companyid, branchId])

  const convertTimestampToDateTime = (timestamp) => {
    const date = new Date(timestamp);

    // Get the individual components (day, month, year, hours, minutes, seconds)
    const day = date.getDate();
    const month = date.getMonth() + 1; // Note: Months are zero-based, so we add 1
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Create a formatted date and time string
    const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

    return formattedDateTime;
  }

  const formatDateTime = (value) => {
    if (!value) {
      return ""; // Return an empty string if value is empty or undefined
    }

    const date = new Date(value);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year} `;
  };




  const [releaseData, setReleaseData] = useState([]);




  const inputRef = useRef();

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      document.getElementById("submitButton").click();
    }
  };


  const inputRef1 = useRef();

  const handleKeyPress1 = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      document.getElementById("submitButton1").click();
    }
  };

  const handleTabChange = async (key) => {
    console.log("New selected tab:", key);

    if (key === "home") {
        // HOLD tab
        await getHoldList("HOLD");
    } else if (key === "profile") {
        // RELEASE tab
        await getHoldList("RELEASE");
    }
};

  return (

    <Container>

      <h5 className="pageHead" style={{ fontFamily: 'Your-Heading-Font', paddingLeft: '4%', paddingRight: '-50px' }} > <FontAwesomeIcon
        icon={faHand}
        style={{
          marginRight: '8px',
          color: 'black'
        }}
      />Hold & Release Parcel</h5>

      <Card  >
        <CardBody>


          <Tabs
            defaultActiveKey="home"
            transition={false}
            id="noanim-tab-example"
            className="mb-3"
            onSelect={handleTabChange}
          >

            <Tab eventKey="home" title="Hold">
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label className="forlabel" for="branchId">Enter or scan Sb/ Sir/ Ser Number</Label>
                    <Input
                      type="text"
                      name="remarks"
                      id="branchname"
                      autoFocus
                      ref={inputRef}
                      onKeyDown={handleKeyPress}
                      placeholder='Scan Sb/ Sir/ Ser Number'
                      onChange={(e) => setGetSir(e.target.value)}
                      value={getSir}
                      className="inputField"

                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <Button id="submitButton" variant="outline-primary" onClick={handlesub} style={{ marginTop: 32 }}>
                    <FontAwesomeIcon icon={faSearch} style={{ marginRight: '5px' }} />
                    Scan
                  </Button>
                </Col>
                <Col></Col>
              </Row>

              {holdList && holdList.length > 0 && (

                <Row style={{ marginTop: 30 }}>

                  <div className="table-responsive">
                    <Table className="table table-bordered table-hover text-center mt-1" style={{ border: '2px solid black' }}>
                      <thead className="thead-dark bg-dark">
                        <tr style={{ fontWeight: 'bold', border: '2px solid black', fontSize: '17px' }}>
                          <th style={{ backgroundColor: '#BADDDA' }}>SR NO.</th>

                          <th style={{ backgroundColor: '#BADDDA' }}>TYPE</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>SIR/SER Number</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>SB/MAWB</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>REQUEST/HAWB</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>PARTY NAME</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>HOLD DATE</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>HOLD BY</th>

                        </tr>
                      </thead>
                      <tbody tbody className="text-center">

                        {holdList.map((item, index) => {
                          const comboNotPresent = item.forwardedInStatus === 'N';
                          return (
                            <tr key={index} className='text-center'>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{index + 1}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.parcelType}</td>

                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.sirNo}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.erpDocRefNo}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.docRefNo}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.partyName}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{convertTimestampToDateTime(item.transactionDate)}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.holdBy}</td>
                            </tr>
                          );
                        })}

                      </tbody>
                    </Table>
                  </div>

                </Row>

              )}

            </Tab>
            <Tab eventKey="profile" title="Release">
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label className="forlabel" for="branchId">Scan URL</Label>
                    <Input
                      type="text"
                      name="remarks"
                      id="branchname"
                      ref={inputRef1}
                      onKeyDown={handleKeyPress1}
                      placeholder='Scan SIR'
                      onChange={(e) => setGetSir1(e.target.value)}
                      value={getSir1}
                      className="inputField"

                    />
                  </FormGroup>
                </Col>
                <Col>
                  <Button id="submitButton1" onClick={handlesub1} variant="outline-primary" style={{ marginTop: 32 }}>
                    <FontAwesomeIcon icon={faSearch} style={{ marginRight: '5px' }} />
                    Scan
                  </Button>
                </Col>
                <Col></Col>
              </Row>

              {releaseData && releaseData.length > 0 && (

                <Row style={{ marginTop: 30 }}>

<div className="table-responsive">
                    <Table className="table table-bordered table-hover text-center mt-1" style={{ border: '2px solid black' }}>
                      <thead className="thead-dark bg-dark">
                        <tr style={{ fontWeight: 'bold', border: '2px solid black', fontSize: '17px' }}>
                          <th style={{ backgroundColor: '#BADDDA' }}>SR NO.</th>

                          <th style={{ backgroundColor: '#BADDDA' }}>TypTYPEe</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>SIR/SER Number</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>SB/MAWB</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>REQUEST/HAWB</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>PARTY NAME</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>HOLD DATE</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>HOLD BY</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>RELEASE DATE</th>
                          <th style={{ backgroundColor: '#BADDDA' }}>RELEASE BY</th>

                        </tr>
                      </thead>
                      <tbody tbody className="text-center">

                        {releaseData.map((item, index) => {
                          const comboNotPresent = item.forwardedInStatus === 'N';
                          return (
                            <tr key={index} className='text-center'>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{index + 1}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.parcelType}</td>

                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.sirNo}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.erpDocRefNo}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.docRefNo}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.partyName}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{convertTimestampToDateTime(item.transactionDate)}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.holdBy}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{convertTimestampToDateTime(item.releaseDate)}</td>
                              <td className={`text-center ${comboNotPresent ? 'highlight-red' : ''}`}>{item.releaseBy}</td>
                            </tr>
                          );
                        })}

                      </tbody>
                    </Table>
                  </div>

                </Row>


              )}
            </Tab>

          </Tabs>
        </CardBody>
      </Card  >
    </Container>

  )
}
